<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-body border-bottom border-primary" style="border-width: 20px !important;">
        <a class="navbar-brand" href="/dashboard">
            <img src="/storage/lgt-logo.svg?v=1" height="50" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse">
            <div class="d-flex flex-grow-1 flex-column">
                <div class="d-flex flex-grow-1">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/customers">{{ $t('company.menuName') }}</a>
                        </li>
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/services">{{ $t('additional_services.menuName') }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/bookings">{{ $t('booking.menuName') }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/bookings/draft">
                                {{ $t('booking.draftMenuName') }}
                                <span class="badge badge-primary" v-if="draftCount > 0">{{ draftCount }}</span>
                            </a>

                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/pickup">{{ $t('pickup.menuName') }}</a>
                        </li>
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/city-surcharge">{{ $t('city_surcharge.menuName') }}</a>
                        </li>
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/currency">{{ $t('currencies.menuName') }}</a>
                        </li>
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/admin-user">{{ $t('admin_user.menuName') }}</a>
                        </li>
                        <li class="nav-item" v-if="$root.isAdmin">
                            <a class="nav-link" href="/settings/terminal">{{ $t('terminals.menuName') }}</a>
                        </li>

                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            v-if="!$root.isAdmin"
                        >
                            <template v-slot:button-content>
                                {{ $t('savedData.menuName') }}
                            </template>
                            <b-dropdown-item href="/saved-data/loading-address">
                                {{ $t('savedData.types.loadingAddress') }}
                            </b-dropdown-item>
                            <b-dropdown-item href="/saved-data/unloading-address">
                                {{ $t('savedData.types.unloadingAddress') }}
                            </b-dropdown-item>
                            <b-dropdown-item href="/saved-data/recipient">
                                {{ $t('savedData.types.recipient') }}
                            </b-dropdown-item>
                            <b-dropdown-item href="/saved-data/sender-address">
                                {{ $t('savedData.types.senderAddress') }}
                            </b-dropdown-item>
                            <b-dropdown-item href="/saved-data/pickup-address">
                                {{ $t('savedData.types.pickupAddress') }}
                            </b-dropdown-item>
                        </b-nav-item-dropdown>

                        <li class="nav-item">
                            <a class="btn btn-outline-primary" href="/bookings/create" v-if="!$root.isAdmin">{{ $t('booking.new') }}</a>
                        <li class="nav-item">
                            <a class="nav-link" target="_blank" href="/translation" v-if="$root.isAdmin"><img src="/storage/external-link-icon.png" height="13"
                                                                                                              style="margin-top: -4px;"/> {{ $t('core.translations') }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" target="_blank" href="https://zipcode.lgtlogistics.dk"><img src="/storage/external-link-icon.png" height="13"
                                                                                                            style="margin-top: -4px;"/> {{ $t('core.zipcodeLink') }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" target="_blank" href="https://tt.lgtlogistics.dk"><img src="/storage/external-link-icon.png" height="13" style="margin-top: -4px;"/>
                                {{ $t('core.trackAndTraceLink') }}</a>
                        </li>
                    </ul>
                    <ul class="navbar-nav">
                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            right
                        >
                            <template v-slot:button-content>
                                {{ $t('core.languages.' + $root.language) }}
                            </template>
                            <b-dropdown-item v-for="(name, key) in $t('core.languages')" :href="'/switch-language/' + key" :key="key">
                        <span :class="{'font-weight-bold': key === $root.language}">
                        {{ name }}
                        </span>
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item-dropdown
                            id="my-nav-dropdown"
                            right
                        >
                            <template v-slot:button-content>
                                {{ $root.username }}
                            </template>
                            <b-dropdown-item :href="'/change-password/' + $root.userId">
                                {{ $t('user.changePassword') }}
                            </b-dropdown-item>
                            <b-dropdown-item :href="'/company/' + $root.companyId">
                                {{ $t('user.editCompanyData') }}
                            </b-dropdown-item>
                            <b-dropdown-item :href="'/user/' + $root.userId + '/edit'">
                                {{ $t('user.editProfile') }}
                            </b-dropdown-item>
                            <b-dropdown-item onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
                                {{ $t('core.logout') }}
                                <form method="post" id="logout-form" action="/logout" class="d-none"></form>
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </ul>
                </div>
                <div class="d-flex justify-content-end small" v-if="isImpersonating">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a class="nav-link" href="/impersonate/leave">{{ $t('user.stopImpersonate') }}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <SessionLifetimeWarningModal></SessionLifetimeWarningModal>
    </nav>
</template>

<script>
import SessionLifetimeWarningModal from '@/Components/SessionLifetimeWarningModal'

export default {
    name: 'Navbar',
    components: { SessionLifetimeWarningModal },
    data: function () {
        return {
            draftCount: lgt.draftCount,
            isImpersonating: lgt.isImpersonating
        }
    },
}
</script>
